import { Controller } from "@hotwired/stimulus"

// Pagination "Show rows" select: each option's value is the URL for that page size,
// so changing it navigates there (page reset handled in the URL).
export default class extends Controller {
  navigate(event) {
    const url = event.target.value
    if (url) window.location.href = url
  }
}
